module.exports = __webpack_public_path__ + "static/media/icon-lap-1L.9d5a1e1b.svg";